<h2 nxHeadline="section"></h2>
<form [formGroup]="parentForm">
  <qbe-panel-component formGroupName="houseForm">
    <div nxRow class="outer-element inner-element">
      <div nxCol="7" class="inner-element-left">
        <div class="inner-element-title margin4566">{{'details5.personalContactDetails' | translate}}</div>
        <qbe-illustration
          name="woman-with-tablet-talking-to-man"
          class="inner-element-left-illustration"
        ></qbe-illustration>
      </div>
      <div nxCol="5" class="inner-element-right">
        <nx-formfield [label]="'details5.salutation' | translate" class="inner-element-right-item">
            <nx-dropdown [valueFormatter]="toText" formControlName="salutation">
            <nx-dropdown-item *ngFor="let salutation of salutations" [value]="salutation"
                (click)="trackService.addAttribute('salutation',salutation)"
            ></nx-dropdown-item>
            </nx-dropdown>
        </nx-formfield>
        <nx-formfield [label]="'details5.name' | translate" class="inner-element-right-item">
            <input nxInput formControlName="name"
             (change)="trackService.addAttribute('name',  parentForm.controls.houseForm.controls.name.value)"
            >
        </nx-formfield>
        <nx-formfield [label]="'details5.middleName' | translate" class="inner-element-right-item">
          <input nxInput formControlName="middleName"
              (change)="trackService.addAttribute('middleName',  parentForm.controls.houseForm.controls.middleName.value)"
          >
        </nx-formfield>
        <nx-formfield [label]="'details5.surname' | translate" class="inner-element-right-item">
            <input nxInput formControlName="surname"
            (change)="trackService.addAttribute('surname',  parentForm.controls.houseForm.controls.surname.value)"
            >
        </nx-formfield>
        <nx-formfield [label]="'details5.mobileNumber' | translate" class="inner-element-right-item">
            <input nxInput formControlName="mobileNumber"
            (change)="trackService.addAttribute('mobileNumber',  parentForm.controls.houseForm.controls.mobileNumber.value)"
            >
        </nx-formfield>
        <nx-formfield [label]="'details5.email' | translate" class="inner-element-right-item">
            <input nxInput formControlName="email"
            (change)="trackService.pushEventTracking('user.emailAdress',  parentForm.controls.houseForm.controls.email.value)"
            >
        </nx-formfield>
        <nx-formfield [label]="'details5.city' | translate" class="inner-element-right-item">
          <input nxInput disabled [value]="parentForm.value.houseForm.cityName"
          (change)="trackService.addAttribute('city',  parentForm.controls.houseForm.controls.city.value)"
          >
      </nx-formfield>
        <nx-formfield [label]="'details5.postcode' | translate" class="inner-element-right-item">
          <input nxInput disabled [value]="parentForm.value.houseForm.postCode"
          (change)="trackService.pushEventTracking('user.postCode', parentForm.controls.houseForm.controls.postCode.value)"
          >
        </nx-formfield>
        <nx-formfield [label]="'details5.streetNumber' | translate" class="inner-element-right-item">
          <input nxInput disabled [value]="parentForm.value.houseForm.streetNumber"
          (change)="trackService.addAttribute('streetNumber',  parentForm.controls.houseForm.controls.streetNumber.value)"
          >
        </nx-formfield>
      </div>
    </div>
  </qbe-panel-component>
</form>
